import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { memberFetch } from "../lib/memberApi";
import { CheckCircle2, Loader2 } from "lucide-react";

export default function MemberBillingSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get("session_id");
  const invoiceId = params.get("invoice_id");
  const [status, setStatus] = useState("verifying");

  useEffect(() => {
    if (!sessionId || !invoiceId) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      try {
        const d = await memberFetch(`/member/billing/invoices/${invoiceId}/confirm/${sessionId}`);
        if (d.status === "paid") {
          setStatus("paid");
          setTimeout(() => navigate("/member/dashboard?tab=billing"), 1800);
          return;
        }
        attempts += 1;
        if (attempts < 8) setTimeout(poll, 2000);
        else setStatus("pending");
      } catch {
        setStatus("error");
      }
    };
    poll();
  }, [sessionId, invoiceId, navigate]);

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white grid place-items-center px-6" data-testid="billing-success-page">
      <div className="max-w-lg w-full border border-zinc-800 bg-[#141414] p-10 text-center">
        {status === "paid" ? (
          <>
            <CheckCircle2 size={48} className="text-[#E5B43A] mx-auto mb-6" />
            <h1 className="font-display text-4xl mb-3">Invoice Paid</h1>
            <p className="text-zinc-400">Receipt emailed. Redirecting to billing...</p>
          </>
        ) : status === "pending" ? (
          <>
            <h1 className="font-display text-3xl mb-3">Payment Pending</h1>
            <p className="text-zinc-400">Stripe is still confirming. Refresh in a moment.</p>
          </>
        ) : status === "error" ? (
          <>
            <h1 className="font-display text-3xl mb-3">Something went wrong</h1>
            <p className="text-zinc-400">Reach out and we'll fix it.</p>
          </>
        ) : (
          <>
            <Loader2 size={40} className="text-[#E5B43A] mx-auto mb-6 animate-spin" />
            <h1 className="font-display text-3xl mb-3">Verifying...</h1>
          </>
        )}
      </div>
    </div>
  );
}
